import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { IHistoryTotalQtVolLTPerProduct } from "@utils/interfaces";
import { inject, injectable } from "inversify";
import { IGetDataChartsDash } from "../dtos/IGetDataChartsDash";
import { IGetHistoryTotalQtVolLTPerProductService } from "../models/IGetHistoryTotalQtVolLTPerProductService";

@injectable()
export class GetHistoryTotalQtVolLTPerProductService
  implements IGetHistoryTotalQtVolLTPerProductService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  execute(data: IGetDataChartsDash): Promise<IHistoryTotalQtVolLTPerProduct[]> {
    return this.httpInstance.get<IHistoryTotalQtVolLTPerProduct[]>(
      `/dashboard-posh/taxReceipt?action=${data.action}&companies_id=${data.companies_id}&type_date_trunc=${data.type_date_trunc}&from=${data.from}&to=${data.to}`
    );
  }
}
